module.exports = __webpack_public_path__ + "static/img/logo_ycx.d2c3a08.png";


//////////////////
// WEBPACK FOOTER
// ./static/img/logo_ycx.png
// module id = ytBV
// module chunks = 273